module.exports = __webpack_public_path__ + "media/control_acceso/seccional_labeled-6e308251.png";